import {Component, EventEmitter, inject, OnDestroy, OnInit, Output} from '@angular/core';
import {ApiService} from '../services/api-service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Shared} from '../services/shared';
import {AuthService} from '../services/auth';
import {TranslatePipe} from '@ngx-translate/core';


@Component({
  selector: 'app-signin',
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: './signin.html',
  styleUrl: './signin.scss'
})
export class Signin implements OnInit, OnDestroy{
  // @Output() tokenChange = new EventEmitter<boolean>()
  @Output() plan = new EventEmitter<void>();
  @Output() token = new EventEmitter<void>();

  @Output() tokenChange = new EventEmitter<boolean>();
  private authService = inject(AuthService);

  isButtonDisabled = false;

  signInMessageShowSucceed = false
  signInMessageShow = false
  signInMessageShowError = false
  signInMessage: string | undefined = ''

  forgotPass = false
  passcode = false
  completedPasscode = false
  loadingPasscode = false;

  signUp: boolean = false
  signUpMessageShow = false
  signUpMessageShowSucceed = false
  signUpMessageShowError = false
  signUpMessage: string | undefined = ''

  confirmMailMessage = '';
  confirmMailError = '';

  resendConfirm = false;

  private apiService = inject(ApiService);
  private router = inject(Router)
  signInProfileForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8)
    ])
  });

  forgotPassProfileForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  profileForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8)
    ])
  });

  confirmMailProfileForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  logout(): void {
    this.authService.logout().subscribe(() => {
      // window.location.reload();
    });
  }

  // form = this.fb.group({
  //   email: ['', [Validators.required, Validators.email]]
  // });
  sharedService = inject(Shared)

  private requestSignup!: Subscription;
  ngOnInit () {
    this.requestSignup = this.sharedService.requestSignup$.subscribe(() => {

      this.toggleSignInUp()

      // console.log('WORKING')
    });
  }

  ngOnDestroy() {
    this.requestSignup.unsubscribe();
  }

  // constructor(private fb: FormBuilder, private auth: AuthService) {}

  resendConfirmSubmit() {
    this.confirmMailMessage = '';
    this.confirmMailError = '';

    if (this.signInProfileForm.invalid) return;

    const email = this.signInProfileForm.value.email!;
    this.apiService.resendConfirmation(email).subscribe({
      next: (res) => {
        this.confirmMailMessage = res.message || 'Check your inbox for a new confirmation link.';
      },
      error: (err) => {
        this.confirmMailError = err.error?.detail || 'Something went wrong.';
      }
    });
  }



  signInHandleSubmit() {
    this.disableButton();
    this.signInMessageShow = false;
    this.signInMessageShowSucceed = false;
    this.signInMessageShowError = false;
    this.resendConfirm = false;

    const email = this.signInProfileForm.value.email!;
    const password = this.signInProfileForm.value.password!;

    this.authService.setToken(email, password).subscribe({
      next: () => {
        this.signInMessageShow = true;
        this.signInMessage = 'Successfully signed in.';
        this.tokenChange.emit();
        this.plan.emit();



        // this.router.navigate(['/camera']); // uncomment if you want navigation
      },
      error: (error) => {
        this.signInMessageShowError = true;
        if (error.status === 400) {
          this.signInMessage = 'Please confirm your email address.';
          this.resendConfirm = true;
        } else {
          this.signInMessage = 'Invalid email or password.';
        }
      },
      complete: () => {
        this.signInMessageShowSucceed = true;
      }
    });
  }


  forgotPassHandleSubmit() {
    this.loadingPasscode = true
    this.apiService.resetPass(this.forgotPassProfileForm.value.email!).subscribe({
      next: (response: Response) => {
        // console.log('status 200')
        this.passcode = true;
        this.loadingPasscode = false
        // show bootstrap passcode

      },
      error: (error: Response) => {
        // console.log('error')
        this.loadingPasscode = true
      },
      complete: () => {
        // console.log('complete')
        this.completedPasscode = true

      }
    });
  }
  handleSubmit() {
    this.disableButton();
    this.signUpMessageShow = false;
    this.signUpMessageShowSucceed = false;
    this.signUpMessageShowError = false;

    this.apiService.postUser(this.profileForm.value.email!, this.profileForm.value.password!).subscribe({
      next: (response: Response) => {
        this.signUpMessageShow = true
        this.signUpMessage = response.message;
      },
      error: (error: Response) => {
        this.signUpMessageShowError = true
        this.signUpMessage = error.error?.detail;
      },
      complete: () => {
        this.signUpMessageShowSucceed = true
      }
    });
  }

  toggleSignInForgotPass() {
    this.forgotPass = !this.forgotPass;
  }

  toggleSignInUp() {
    this.signUp = !this.signUp;
  }


  status = null
  loading = false

  getStatus(): void {
    this.apiService.getStatus().subscribe({
      next: (data) => {
        this.status = data;
        this.loading = false;
        // console.log('test ' + this.status)
      },
      error: (error) => {
        console.error('Error getting status:', error);
        this.loading = false;
        // console.log('test ' + error)
      }
    });
  }

  disableButton() {
    this.isButtonDisabled = true;

    // Re-enable the button after 2 seconds
    setTimeout(() => {
      this.isButtonDisabled = false;
    }, 1500);
  }
}

interface Response {
  headers?: any; // Use 'any' here as headers are complex and might change
  status: number;
  statusText?: string;
  url?: string;
  ok?: boolean;
  name?: string;
  message: string;
  error?: {       // Optional error object - good practice
    detail: string;
  };
}
